import classNames from "classnames";
import React, { type PropsWithChildren } from "react";

export interface ICalendarHelpDetailRowProps {
  label: string
  gap?: boolean
}

export const ICalendarHelpDetailRow = (props: PropsWithChildren<ICalendarHelpDetailRowProps>) => {

  return <div className="flex-column">
    <div className="icalendar-feed-help-label body-text-regular s1_gray">{props.label}</div>
    <div className={classNames("icalendar-feed-help-text", {
      "icalendar-feed-help-text-gap": props.gap,
    })}>{props.children}</div>
  </div>
}